import { Group } from '.';

export interface GroupConfig {
  groups: Group[];
  groupBy: string;
}
